<form class="p4m-grid-4-col" [formGroup]="formGroup">
  <mat-form-field *ngIf="serviceTypes?.length > 0">
    <mat-label>{{ 'planning.createTracking.serviceType' | translate }}</mat-label>
    <mat-select formControlName="serviceTypeId" id="serviceTypeId">
      <mat-option
        *ngFor="let option of serviceTypes"
        [value]="option.OBJECT_ID"
      >{{ option.TEXT }}
      </mat-option
      >
      <mat-error *ngIf="getErrorMessage(formGroup, 'serviceTypeId')">
        {{ getErrorMessage(formGroup, 'serviceTypeId') }}
      </mat-error>
    </mat-select>
  </mat-form-field>

  <mat-form-field *ngIf="ratingTypes?.length > 0">
    <mat-label>{{ 'planning.createTracking.ratingType' | translate }}</mat-label>
    <mat-select
      formControlName="ratingTypeId"
      id="ratingTypeId"
      (valueChange)="onRatingTypeChanged()">
      <mat-option
        *ngFor="let option of ratingTypes"
        [value]="option.OBJECT_ID"
      >{{ option.TEXT }}
      </mat-option
      >
      <mat-error *ngIf="getErrorMessage(formGroup, 'ratingTypeId')">
        {{ getErrorMessage(formGroup, 'ratingTypeId') }}
      </mat-error>
    </mat-select>
  </mat-form-field>

  <mat-form-field *ngIf="positions?.length > 0">
    <mat-label>Position</mat-label>
    <mat-select formControlName="posId">
      <mat-option *ngFor="let option of positions" [value]="option.OBJECT_ID">{{
          option.TEXT
        }}
      </mat-option>
      <mat-error *ngIf="getErrorMessage(formGroup, 'posId')">
        {{ getErrorMessage(formGroup, 'posId') }}
      </mat-error>
    </mat-select>
  </mat-form-field>

  <mat-form-field *ngIf="activities?.length > 0">
    <mat-label>{{ 'planning.createTracking.activity' | translate }}</mat-label>
    <mat-select formControlName="activityId">
      <mat-option
        *ngFor="let activity of activities"
        [value]="activity.OBJECT_ID"
      >{{ activity.TEXT }}
      </mat-option
      >
      <mat-error *ngIf="getErrorMessage(formGroup, 'activityId')">
        {{ getErrorMessage(formGroup, 'activityId') }}
      </mat-error>
    </mat-select>
  </mat-form-field>
</form>
